export default "__VITE_ASSET__DxzgvLBk__"